import { FC } from 'react';
import Teaser from './teaser';
import CrowdFunding from './crowdfunding';
import Detail from './detail';
import { Delta2MaxProps, STAGES } from '@/constants/delta2max';
import EfScrollAni from '@/efscrollani';

const Delta2MaxPC: FC<Delta2MaxProps> = ({ stage, productDetail, resProductCatagory, supportData, crowdfundingTimeline, nowSysTime }: Delta2MaxProps) => {
    const props: any = {
        productDetail,
        resProductCatagory,
        crowdfundingTimeline,
        supportData,
        nowSysTime,
        stage,
    };
    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }
    console.log('stage', stage);
    return (
        <div className="delta-2-max">
            {stage === STAGES.TEASER && <Teaser />}
            {stage === STAGES.CROWDFUNDING && <CrowdFunding {...props} />}
            {stage === STAGES.DETAIL && <Detail stage={stage} />}
        </div>
    );
};

export default Delta2MaxPC;
